<hr>

<div class="row">
  <div class="col-xs-12">
    <h2 class="default">Results ({{numberOfResults}})
      <button class="btn btn-light" [disabled]="disablePrint" printSectionId="printContent" ngxPrint [useExistingCss]="true">Print</button>
      <button class="btn btn-light" [disabled]="disablePrint" (click)="saveAsCsv()">Download</button>
    </h2>
  </div>
</div>

<div class="row">
  <div class="col-sm-12">
    <table class="table emds-table table-sticky-header table-striped table-border-top table-flush-top">
      <thead>
        <tr>
          <th>Date</th>
          <th>Time</th>
          <th>Patient Name</th>
          <th>Type</th>
          <th>Status</th>
          <th class="nowrap">Rendering Provider</th>
          <th class="nowrap">Service Site</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let result of resultView, let i = index">
          <td class="nowrap" id="{{Id}}-date-{{i}}">
            {{result.Date | date: 'MM/dd/yyyy'}}
          </td>
          <td class="nowrap" id="{{Id}}-time-{{i}}">
            {{result.Date | date: 'shortTime'}}
          </td>
          <td id="{{Id}}-patient-name-{{i}}">
            {{result.PatientName}}
          </td>
          <td id="{{Id}}-appointment-type-{{i}}">
            {{result.AppointmentType}}
          </td>
          <td id="{{Id}}-appointment-status-{{i}}">
            {{result.Status}}
          </td>
          <td id="{{Id}}-rendering-provider-{{i}}">
            {{result.RenderingProvider}}
          </td>
          <td id="{{Id}}-service-site-{{i}}">
            {{result.ServiceSite}}
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="totalItems === 0">No Results Found</div>
    <pagination [totalItems]="totalItems" (pageChanged)="pageChanged($event)" itemsPerPage="10" [(ngModel)]="currentPage"></pagination>
  </div>
</div>
